import React from "react";

const Footer = () => {
  return (
    <div className="w-full py-10 border-b-[1px] border-black text-xl text-center">
      <span>&#xa9; Phil Page | Login-Page - {new Date().getFullYear()} </span>
    </div>
  );
};

export default Footer;
